// @flow
import * as R from "ramda"

type DefaultValue = *
type Path = string | number | Array<string | number>
type Input = *

const getValue = (path: Path, input: Input) => {
  // $FlowIssue
  const pathArr: Array<string | number> = Array.isArray(path) ? path : String(path).split(".")
  const pathLens = R.lensPath(pathArr)

  return R.view(pathLens, input)
}

export const getOr = R.curry((defaultValue: DefaultValue, path: Path, input: Input) => {
  const value = getValue(path, input)

  return value === undefined ? defaultValue : value
})

export const get = R.curry(getValue)
